
import { FamilyMember } from '@/types';

export function searchMembers(query: string, members: FamilyMember[]): Array<{ member: FamilyMember; lineage: string }> {
  const searchParts = query.trim();
  const results: Array<{ member: FamilyMember; lineage: string }> = [];

  members.forEach(member => {
    const fullName = getFullName(member, members); // Pass members array
    if (fullName.startsWith(searchParts)) {
      results.push({ 
        member, 
        lineage: getFullName(member, members)  // Pass members array
      });
    }
  });

  return results;
}

// Helper function to get full name with ancestry
function getFullName(member, members) {
  const ancestry = [];
  let current = member;
  
  while (current) {
    ancestry.push(current.name);
    current = members.find(m => m.id === current.parentId);
  }
  
  return ancestry.join(' بن ');
};